import { useIntl } from "react-intl";
import { BudgetStatus } from "../enums/budgetStatus";

export const getStatusBadgeClass = (status: string): string => {
  const statusLower = status.toLowerCase();
  if (
    statusLower.includes("enviado") ||
    statusLower.includes("sent") ||
    statusLower === "enviado"
  ) {
    return "bg-blue-100 text-blue-700";
  }
  if (
    statusLower.includes("aprovado") ||
    statusLower.includes("approved")
  ) {
    return "bg-green-100 text-green-700";
  }
  if (
    statusLower.includes("recusado") ||
    statusLower.includes("rejected") ||
    statusLower.includes("rejeitado")
  ) {
    return "bg-red-100 text-red-700";
  }
  if (statusLower.includes("criado") || statusLower.includes("created")) {
    return "bg-gray-100 text-gray-700";
  }
  return "bg-gray-100 text-gray-700";
};

export const getRecipientLabel = (recipient: string): string => {
  const intl = useIntl();
  switch (recipient) {
    case "CONSULTANT":
      return intl.formatMessage({ id: "intl-msg:budgets.kanban.consultant" });
    case "FACTORY":
      return intl.formatMessage({ id: "intl-msg:budgets.kanban.volkstok" });
    case "MANAGER":
      return intl.formatMessage({ id: "intl-msg:budgets.kanban.manager" });
    default:
      return recipient;
  }
};

export const getStatusStyles = (status: string) => {
  switch (status) {
    case "Aprovado pelo gestor":
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "",
        buttonBg: "",
        buttonText: "text-gray-900",
      };
    case "Contraproposta":
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "",
        buttonBg: "",
        buttonText: "text-gray-900",
      };
    case "Recusado":
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "border-red-200",
        buttonBg: "bg-red-500",
        buttonText: "text-white",
      };
    case "Enviado":
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "",
        buttonBg: "",
        buttonText: "text-gray-900",
      };
    case "Alterado":
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "",
        buttonBg: "bg-gray-600",
        buttonText: "text-white",
      };
    default:
      return {
        cardBg: "bg-[#FFFFFF]",
        border: "border-gray-200",
        buttonBg: "bg-gray-300",
        buttonText: "text-black",
      };
  }
};

export const getBorderColor = (status: string): string => {
  switch (status) {
    case "Aprovado pelo gestor":
      return "#5CB85C";
    case "Contraproposta":
      return "#FF8E3C";
    case "Enviado":
      return "#F9FAFB";
    case "Alterado":
      return "#6B7280";
    case "Recusado":
      return "#EF4444";
    default:
      return "";
  }
};

export const getButtonBackgroundColor = (status: string): string => {
  switch (status) {
    case "Aprovado pelo gestor":
      return "#ABEFC6";
    case "Contraproposta":
      return "#F9DBAF";
    case "Enviado":
      return "#E4E7EC";
    default:
      return "";
  }
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case BudgetStatus.PENDING:
    case "Pendente":
      return "bg-gray text-gray-600 font-bold";
    case BudgetStatus.APPROVED:
    case "Aprovado":
      return "bg-green-500 text-white font-bold";
    case BudgetStatus.REJECTED:
    case "Recusado":
      return "bg-red-500 text-white font-bold";
    case BudgetStatus.CHANGED:
    case BudgetStatus.COUNTER_PROPOSAL:
    case "Alterado":
    case "Contraproposta":
      return "bg-orange-500 text-white font-bold";
    default:
      return "bg-gray text-gray-600 font-bold";
  }
};

export const getStatusLabel = (status: BudgetStatus): string => {
  const intl = useIntl();
  switch (status) {
    case BudgetStatus.PENDING:
      return intl.formatMessage({ id: "intl-msg:budgets.kanban.pending" });
    case BudgetStatus.APPROVED:
      return intl.formatMessage({ id: "intl-msg:budgets.kanban.approved" });
    case BudgetStatus.REJECTED:
      return intl.formatMessage({ id: "intl-msg:budgets.kanban.rejected" });
    case BudgetStatus.CHANGED:
      return intl.formatMessage({ id: "intl-msg:budgets.kanban.changed" });
    case BudgetStatus.COUNTER_PROPOSAL:
      return intl.formatMessage({ id: "intl-msg:budgets.kanban.counterProposal" });
  }
};